import React from 'react';
import { isMobilePhone, isMobileTablet, isFireFox} from '../../../library/calc';
import { Rect, Text, Image } from 'react-konva';

const adjustTop = -3;
const adjustLeft = 1;

export class Icon extends React.Component {

    constructor(props){
      super(props);
      this.props.buildRefObj({key: `matchicon_n-${this.props.node}`, objClass: this});
    }

    click(){


    }

    onMouseenter(){

      let {
        node,
        showMatchBubbleFor,
        stopStageClickPropagation,
        cursorBecomesPointer,
        skipZoomInOutSteppingNow,
      } = this.props;

        skipZoomInOutSteppingNow();
        stopStageClickPropagation({fromWhere:'magnify count B'});
        showMatchBubbleFor(node);
        cursorBecomesPointer();

    }

    onMouseleave(){

      let {
        stopStageClickPropagation,
        cursorBecomesMove,
      } = this.props;

      stopStageClickPropagation({fromWhere:'magnify count C'});
      cursorBecomesMove();

    }

    render() {
      let {
        node,
        left,
        top,
        magnifyImage,
        showMatchBubbleFor,
        stopStageClickPropagation,
        // cursorBecomesMove,
        // cursorBecomesPointer,
        userTouchedNode,
        skipZoomInOutSteppingNow,
      } = this.props;

      left += adjustLeft - 5;
      top += adjustTop;

      return (
          <Image
            image={magnifyImage}
            scaleX={.1}
            scaleY={.1}
            width={9 * 10}
            height={9* 10}
            x={left}
            y={top}

            onTouchStart={()=>{
              stopStageClickPropagation({fromWhere:'magnify count A'});
              userTouchedNode({
                node,
                callback: ()=>{
                  showMatchBubbleFor(node);
                },
                fromWhere:'Matchcount Icon'}
              );
            }}

            onClick={(ev)=>{
              skipZoomInOutSteppingNow();
              return false;
            }}

            onMouseenter={this.onMouseenter.bind(this)}

            // onMouseenter={()=>{
            //   skipZoomInOutSteppingNow();
            //   stopStageClickPropagation({fromWhere:'magnify count B'});
            //   showMatchBubbleFor(node);
            //   cursorBecomesPointer();
            // }}

            onMouseleave={this.onMouseleave.bind(this)}

            // onMouseleave={()=>{
            //   stopStageClickPropagation({fromWhere:'magnify count C'});
            //   cursorBecomesMove();
            // }}
          />
      );
    }
}

export const Oval = ({
    node,
    match_count,
    left,
    top,
    showMatchBubbleFor,
    stopStageClickPropagation,
    zoomOutFromMobileFlipCard,
    vsum,
    cursorBecomesMove,
    cursorBecomesPointer,
    userTouchedNode,
    skipZoomInOutSteppingNow,
  }) => {

  let width = 7;
  left += adjustLeft - 1;
  top += adjustTop - 2;

  if(parseInt(match_count, 10) > 9) width += 2.6;
  if(match_count === '99+') width += 2.8;

  return <Rect
    x={left}
    y={top}
    width={width}
    height={7}
    cursor="pointer"
    fill="#1166BB"
    cornerRadius={3.5}

    onTouchStart={()=>{
      console.log('touched match count');
      stopStageClickPropagation({fromWhere:'magnify count D'});
      userTouchedNode({
        node,
        callback: ()=>{
          showMatchBubbleFor(node);
        },
        fromWhere:'Matchcount Oval'}
      );
    }}

    onClick={(ev)=>{
      skipZoomInOutSteppingNow();
    }}

    onMouseenter={()=>{
      skipZoomInOutSteppingNow();
      showMatchBubbleFor(node);
      stopStageClickPropagation({fromWhere:'magnify count E'});
      cursorBecomesPointer();
    }}
    onMouseleave={()=>{
      showMatchBubbleFor(node);
      stopStageClickPropagation({fromWhere:'magnify count F'});
      cursorBecomesMove();
    }}
  />;
};



export const Matchcount = ({
    node,
    match_count,
    left,
    top,
    showMatchBubbleFor,
    stopStageClickPropagation,
    zoomOutFromMobileFlipCard,
    vsum,
    cursorBecomesMove,
    userTouchedNode,
    cursorBecomesPointer,
    skipZoomInOutSteppingNow,
  }) => {

    left += adjustLeft + 1;

    let shift = .8;

    if(isMobilePhone()){
      shift = .5;
    } else if(isMobileTablet()){
      shift = .5;
    } else if(isFireFox()){
      shift = 0;
    }

    top += adjustTop - shift

    return <Text
      x={left}
      y={top}
      text={match_count}
      fontSize={5}
      fill='white'
      width='auto'
      onTouchStart={()=>{
        console.log('touched match count');
        stopStageClickPropagation({fromWhere:'magnify count G'});
        userTouchedNode({
          node,
          callback: ()=>{
            showMatchBubbleFor(node);
          },
          fromWhere:'Matchcount'}
        );
      }}

      onClick={(ev)=>{
        skipZoomInOutSteppingNow();
      }}

      onMouseenter={()=>{
        skipZoomInOutSteppingNow();
        showMatchBubbleFor(node);
        stopStageClickPropagation({fromWhere:'magnify count H'});
        cursorBecomesPointer();
      }}

      onMouseleave={()=>{
        showMatchBubbleFor(node);
        stopStageClickPropagation({fromWhere:'magnify count I'});
        cursorBecomesMove();
      }}
    />;
  };

